import * as tw from 'rev.sdk.js/Locale/tw';

const labels = {
  ...tw.labels,
  intro: '介紹',
  spec: '規格',
  remark: '備註',
  share_link: '複製分享連結',
  confirm: '確認',
  customer_support: '聯絡我們',
  customer_support_title: '問題類型',
  customer_support_content: '詢問內容',
  name: '姓名',
  phone: '手機號碼',
  email: '信箱',
  updated: '更新時間',
  next_article: '上一篇',
  prev_article: '下一篇',
  cart: '購物車',
  cart_add: '加入購物車',
  cart_add_error_message_items_limit: '超過購物車購買上限，請分批購買',
  cart_add_error_message: '發生錯誤, 請至個人頁面按下「清除購物車」再重新嘗試',
  cart_clear: '清除購物車',
  cart_clear_success: '清除購物車成功',
  cart_clear_failure: '清除購物車失敗，請與客服人員聯繫',
  cart_empty_content: '您的購物車無任何商品',
  cart_invalid_date: '日期錯誤，請重新選擇日期',
  cart_invalid_extra_data: '欄位有缺失，請將選項完成',
  cart_date_mismatch: '取貨時間 與購物車其他商品衝突',
  cart_logistics_mismatch: '取貨方式 與購物車其他商品衝突',
  cart_thermosphere_mismatch: '商品溫層 與購物車其他商品衝突',
  cart_config_mismatch: '購物車商品出現衝突，請檢查購物車',
  cart_invalid_qty: '宅配數量限制一份，請分開下單',
  cart_exceed_limit: '購物車宅配商品數量超過限制，請分開下單',
  buy_now: '立即購買',
  checkout_info: '寄送資訊',
  cart_empty: 'Cart Empty',
  sale_start_time: '供應開始時間',
  sale_end_time: '供應結束時間',
  cart_items: '購物清單',
  store_info: '店舖資訊',
  contact_us: '聯絡我們',
  customer_order_question: '客服/訂單問題',
  business_coop: '商業合作',
  customer_service: '顧客服務',
  uni_no: '統編',
  store_intro: '門市介紹',
  faq: '常見問題',
  agree_policy_if_register: '擁有帳號即代表您同意',
  privacy_policy: '隱私權政策',
  and: '及',
  service_policy: '服務條款',
  wait: '請稍候',
  profile: '個人資訊',
  gender: '性別',
  male: '男',
  female: '女',
  login_way: '登入方式',
  action: '動作',
  reset: '重設',
  submit: '送出',
  zip_code: '郵遞區號',
  city: '縣市',
  district: '鄉鎮市區',
  address: '地址',
  order_title: '我的訂單',
  reset_password: '重設密碼',
  original_pwd: '舊密碼',
  new_pwd: '新密碼',
  new_pwd_again: '重新輸入新密碼',
  forgot_pwd: '忘記密碼',
  success: '成功',
  confirm_email_for_reset_pwd: '請到您申請的信箱點擊認證連結, 以便重設密碼!',
  failed: '失敗',
  fail_again: '失敗, 請重新嘗試一次',
  send_verify_email: '傳送認證信',
  please_enter: '請輸入',
  please_select: '請選擇',
  reset_pwd_success_and_login: '您的密碼已重設, 現在可以用新密碼重新登入摟!',
  register_new_account: '註冊新帳號',
  confirm_email_for_register: '請到您申請的信箱點擊認證連結, 完成註冊流程!',
  register: '註冊',
  register_complete: '完成註冊流程',
  account_created_now_login: '您的帳戶已經建立, 現在可以用新密碼重新登入',
  pwd_again: '再次輸入密碼',
  sold_out: '已售完',
  product_list: '商品列表',
  news: '最新消息',
  logistics_type: '取貨方式',
  eta: '預計取貨/送達日期',
  reminder: '提醒',
  line_redirect: 'Line登入跳轉',
  redirect_waiting: '正在嘗試跳轉，請稍等',
  payment: '付款',
  authentication_processing: '認證中',
  price_information: '金額資訊',
  subtotal: '小計',
  total: '總金額',
  prev_step: '上一步',
  next_step: '下一步',
  temperature_zone: '溫層',
  logistics_provider: '物流商',
  invoice_info: '發票資訊',
  extra_info: '其他資訊',
  payment_method: '付款方式',
  tel: '市話',
  receiver_tel_ext: '市話分機',
  note: '備註',
  invoice_type: '發票種類',
  invoice_status: '發票狀態',
  invoice_number: '發票號碼',
  random_code: '發票隨機碼',
  uni_number: '統一編號',
  love_code: '愛心捐贈碼',
  carrier_type: '載具類型',
  carrier_no: '載具條碼',
  citizen_digital_certificate: '自然人憑證條碼',
  company_name: '公司名稱',
  checkout: '結帳',
  order_id: '訂單編號',
  logistics_info: '物流資訊',
  logistics_id: '物流單編號',
  logistics_status: '物流狀態',
  logistics_message: '物流訊息',
  logistics_tracking_no: '貨態查詢編號',
  tracking: '貨態查詢',
  back: '返回',
  login_first: '請先登入',
  pick_time: '自取時間',
  pick_address: '自取地點',
  is_required: '為必填值',
  not_support_logsitic: '不支援此物流',
};

export {labels};
